(function () {
  function initTzGifts() {
    if (!window.tzFreeGiftsConfig || !window.tzFreeGiftsConfig.thresholds) {
      setTimeout(initTzGifts, 300);
      return;
    }

    document.addEventListener('click', (e) => {
      if (e.target.matches('.add-gift-button')) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();

        const btn = e.target;
        const productId = btn.dataset.productId;
        const rangeKey = btn.dataset.range;

        const block = btn.closest('.gift-threshold-block');
        if (block) block.remove();

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            id: productId,
            quantity: 1,
            properties: {
              is_free_gift: true,
              _gift_series_range: rangeKey
            }
          })
        })
          .then(() => fetch('/cart.js'))
          .then(res => res.json())
          .then(cart => {
            document.dispatchEvent(new CustomEvent('theme:cart:change', {
              detail: { cart },
              bubbles: true
            }));

            document.dispatchEvent(new CustomEvent('theme:cart:reload', { bubbles: true }));

            if (window.cartItems?.loadHTML) {
              window.cartItems.loadHTML(cart);
            }
          });
      }
    });

    fetch('/cart.js')
      .then(res => res.json())
      .then(cart => renderTzGifts(cart));
  }

  async function renderTzGifts(cart) {
    const wrapper = document.querySelector('#free-gifts-wrapper');
    if (!wrapper) return;
    wrapper.innerHTML = '';
    if (window.tzFreeGiftsConfig) {
      for (const threshold of window.tzFreeGiftsConfig.thresholds) {
        const { min, max, eligibleTag, rangeKey } = threshold;

        let subtotal = 0;
        for (const item of cart.items) {
          if (!item.handle) continue;
          try {
            const product = await fetch(`/products/${item.handle}.js`).then(r => r.json());
            if (product.tags.includes(eligibleTag)) {
              subtotal += item.line_price / 100;
            }
          } catch {}
        }

        const inRange = subtotal >= min && (max === 99999 || subtotal < max);
        const giftInOtherRange = cart.items.find(item =>
          item.properties?._gift_series_range &&
          item.properties._gift_series_range !== rangeKey
        );
        const giftInThisRange = cart.items.find(item =>
          item.properties?._gift_series_range === rangeKey
        );

        // ukloni poklon iz drugog tier-a ako prelazimo u novi
        if (inRange && giftInOtherRange) {
          await fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: giftInOtherRange.key, quantity: 0 })
          });
          console.log('🗑️ Removed gift from previous range');
        }

        // ukloni poklon ako više nije u pragu
        if (!inRange && giftInThisRange) {
          console.log('🧹 Removing out-of-range gift', giftInThisRange.key);

          await fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: giftInThisRange.key, quantity: 0 })
          });

          const updatedCart = await fetch('/cart.js').then(res => res.json());

          if (window.cartItems?.loadHTML) {
            window.cartItems.loadHTML(updatedCart);
          }

          document.dispatchEvent(new CustomEvent('theme:cart:change', {
            detail: { cart: updatedCart },
            bubbles: true
          }));

          document.dispatchEvent(new CustomEvent('theme:cart:reload', { bubbles: true }));

          return; // prekini dalje za ovaj threshold
        }

        const safeRangeKey = rangeKey.replace(/\./g, '-');
        const existingBlock = document.querySelector(`#gift-series-${safeRangeKey}`);
        if (existingBlock) continue;

        if (inRange && !giftInThisRange) {
          const block = document.createElement('div');
          block.className = 'gift-threshold-block';
          block.id = `gift-series-${safeRangeKey}`;
          block.innerHTML = `
            <h3 class="text-base font-semibold mb-2 text-left pl-[10px]">
              ${(window.location.hostname.includes('tweezerman.de') || window.location.hostname.includes('zwallingbeauty.com')) ? 'Wählen Sie Ihr Gratisgeschenk' : 'Select your free gift!'}
            </h3>
            <div class="flex flex-wrap gap-4 px-[10px]">
              ${threshold.products.map(p => `
                <div class="gift-product flex items-center gap-4 border p-3 rounded mb-2 w-full">
                  <img src="${p.image}" alt="" class="w-[20%] max-w-[80px] h-auto object-contain rounded" />
                  <div class="flex flex-col w-[80%]">
                    <p class="text-sm font-semibold mb-2">${p.title}</p>
                    <button class="add-gift-button bg-black text-white text-xs px-3 py-2 rounded self-start"
                      data-product-id="${p.id}"
                      data-range="${rangeKey}">
                      ${(window.location.hostname.includes('tweezerman.de') || window.location.hostname.includes('zwallingbeauty.com')) ? 'Geschenk hinzufügen' : 'Add Free Gift'}
                    </button>
                  </div>
                </div>
              `).join('')}
            </div>
          `;
          wrapper.appendChild(block);
        }
      }
    }
  }

  let renderTimeout;
  document.addEventListener('theme:cart:change', (e) => {
    clearTimeout(renderTimeout);
    renderTimeout = setTimeout(() => {
      const cart = e.detail?.cart;
      if (cart) {
        renderTzGifts(cart);
      } else {
        fetch('/cart.js').then(res => res.json()).then(renderTzGifts);
      }
    }, 150);
  });

  initTzGifts();
})();
